// extracted by mini-css-extract-plugin
export default {"container":"ml-z","heading":"nl-z","items":"ol-z","action":"pl-z","disabled":"ql-z"};